<template>
        <div class="formgrid grid">
            <div class="field col-12">
                <h2>{{dictionary.simpleNewsletterSignupHeadline}}</h2>
                <p>{{ dictionary.simpleNewsletterSignupText }}</p>
            </div>
            <div class="field col-12">
                <label for="brandSelect">{{dictionary.simpleNewsletterSignupBrandLabel}}</label>
                <Dropdown id="brandSelect" v-model="pickedBrand" :options="brands" optionLabel="name" optionValue="id"
                    :placeholder="dictionary.simpleNewsletterSignupBrandPlaceholder" :disabled="isLoading">

                </Dropdown>
            </div>
            <div v-if="shops.length" class="field col-12">
                <label for="shopSelect">{{dictionary.simpleNewsletterSignupShopLabel}}</label>
                <Dropdown id="shopSelect" v-model="pickedShop" :options="shops" optionLabel="departmentName"
                    optionValue="id" :placeholder="dictionary.simpleNewsletterSignupShopPlaceholder" :disabled="isLoading" />
              
            </div>
            <div v-if="consents" class="field col-12">
                <Button @click="revokeConsent" :label="dictionary.simpleNewsletterSignupRevokeConsentButtonLabel" icon="pi pi-times"
                icon-pos="right" severity="danger" class="p-button-sm"></Button>
            </div>
            
        <DynamicDialog></DynamicDialog>
        </div>


</template>
<script>
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';
import DynamicDialog from 'primevue/dynamicdialog';
import ConsentDialogContent from './consentDialogContent';

export default {
    name: "simpleNewsletterSignup",
    components: {
        Dropdown,
        Button,
        DynamicDialog,
        ConsentDialogContent
    },
    data() {
        return {
            dictionary: [],
            isLoading: false,
            brands: [],
            pickedBrand: null,
            shops: [],
            pickedShop: null,
            consents: false,
            consentTextId: null,
            isDialogActive: false,
        };
    },
    created() {
        const vm = this;

        fetch('/umbraco/api/resourcesApi/GetSimpleNewsletterSignupResources').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data.dictionary;
                vm.brands = data.brands;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    watch: {
        pickedBrand(newVal, oldVal) {
            if (newVal != oldVal) {
                this.pickedShop = null;
                this.consents = false;
                this.consentTextId = null;
                this.getShops();
            }
        },
        pickedShop(newVal, oldVal) {
            if (newVal != oldVal && newVal != null) {
                this.getConsent();
            }
        },
        consents(newVal, oldVal) {
            if (newVal != oldVal) {
                if (newVal == true) {
                    this.$emit('consentChanged', { brand: this.pickedBrand, consentTextId: this.consentTextId, shopId: this.pickedShop,parentShopId:this.shops.find(x=>x.id == this.pickedShop).parentShopId });

                } else {
                    this.$emit('consentChanged', null);

                }
            }
        }
    },
    methods: {
        revokeConsent() {
            this.consents = false;
            this.consentTextId = null;
            this.pickedShop = null;
        },
        async getShops() {
            const vm = this;
            vm.toggleSpinner(true);
            const response = await fetch('/umbraco/api/shopApi/GetShopsByBrand?brand=' + vm.pickedBrand);
            const data = await response.json();
            if (data) {
                if (vm.pickedBrand == 'VolkswagenErhverv') {
                    vm.shops = data.map(x => x.departments.find(x => x.typeId == 5 || x.typeId == 16)).filter(x => x !== undefined);
                } else {
                    vm.shops = data.map(x => x.departments.find(x => x.typeId == 2)).filter(x => x !== undefined);
                }
            }

            vm.toggleSpinner(false);

        },
        async getConsent() {
            const vm = this;
            const brandModelIndex = vm.brands.findIndex(x => x.id == vm.pickedBrand);
            vm.toggleSpinner(true);
            try {
                const response = await fetch('/umbraco/api/consentApi/GetConsentText?brand=' + vm.pickedBrand);
                const data = await response.json();

                vm.toggleSpinner(false);


                vm.$dialog.open(ConsentDialogContent, {
                    props: {
                        header: vm.dictionary.consentDialogHeader.replace('{brand}', vm.brands[brandModelIndex].name),
                        modal: true,
                        blockScroll: true,
                        draggable: false,
                    },
                    data: {
                        consentText: data.text,
                        consentTextId: data.id,
                        labelText: vm.dictionary.consentDialogLabelText,
                        buttonText: vm.dictionary.consentDialogButtonText
                    },
                    onClose: (e) => {
                        if (e.data?.accepted) {
                            vm.consentTextId = data.id;
                            vm.consents = true;
                        }
                    }
                });


            } catch (error) {
                vm.toggleSpinner(false);
                vm.consents = false;
                vm.consentTextId = null;
                console.log(error);
            }

        },

        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;

            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        }
    }
};
</script>
